import { render, staticRenderFns } from "./AccettazionePrenotazioniLazioListPage.vue?vue&type=template&id=3837b9d6&scoped=true"
import script from "./AccettazionePrenotazioniLazioListPage.vue?vue&type=script&lang=js"
export * from "./AccettazionePrenotazioniLazioListPage.vue?vue&type=script&lang=js"
import style0 from "./AccettazionePrenotazioniLazioListPage.vue?vue&type=style&index=0&id=3837b9d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3837b9d6",
  null
  
)

export default component.exports